import script from "./BaseFile.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseFile.vue?vue&type=script&setup=true&lang=js"

import "./BaseFile.vue?vue&type=style&index=0&id=3ca6419e&lang=css"

const __exports__ = script;

export default __exports__